// extracted by mini-css-extract-plugin
export default {"img":"Error404_img__qnMLN","btnGrp":"Error404_btnGrp__gnjXc","btn":"Error404_btn__q7OO7"};